import { FC } from 'react'
import { Box, useTheme } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { defaultApplicationLogoImage, getFullImageUrl } from 'utils'
import { Tooltip } from 'packages/eid-ui'
import { Instructions } from 'components/ApplicationBanner/Instructions'
import { useTranslation } from 'react-i18next'
import { isNilOrEmpty } from 'packages/core'

export interface IApplicationImageProps {
    attribute: any
    data: any
}

const ApplicationImage: FC<IApplicationImageProps> = (props) => {
    const theme = useTheme()

    const { t } = useTranslation()

    const { attribute, data } = props

    const url = data[attribute.name]

    const getTooltipTitle = () => t('Common_MoreInfo')
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '62px',
                minHeight: '32px',
                paddingTop: '4px',
                paddingBottom: '4px',
            }}
        >
            <img
                style={{ maxHeight: '48px' }}
                src={
                    isNilOrEmpty(url)
                        ? getFullImageUrl(defaultApplicationLogoImage)
                        : getFullImageUrl(url)
                }
                alt="app logo"
            />

            {data && data.instructions && (
                <Instructions
                    title={data.friendlyName}
                    instructions={data.instructions}
                    button={(onClick: any) => (
                        <Tooltip title={getTooltipTitle()}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    right: '-8px',
                                    top: '-10px',
                                }}
                                onClick={() => onClick(true)}
                            >
                                <Icon
                                    name="Info"
                                    color={theme?.palette?.grey?.[900]}
                                    width="24px"
                                    height="25px"
                                ></Icon>
                            </Box>
                        </Tooltip>
                    )}
                />
            )}
        </Box>
    )
}
export default ApplicationImage
